/**
 * superFetchV1,superFetchV2의 요청 상태를 가지고 있는 class -> 전역 로딩을 여부 판단 목적
 * superFetchV1,superFetchV2가 하나의 요청 상태를 가지고 있어야 전역 로딩이 정상적으로 동작
 * 하나의 페이지에 버전이 하나만 있으면 문제가 없지만 동시에 두가지 버전의 superFetch 요청을 할때 문제가 발생
 * 싱글톤으로 export 하여 v1,v2에서 사용
 * */
class FetchRequestList {
  private requestList: string[] = [];
  private static instance: FetchRequestList;

  add(url: string): void {
    this.requestList.push(url);
  }
  complete(url: string): void {
    this.requestList = this.requestList.filter((prev) => prev !== url);
  }
  reset(): void {
    this.requestList = [];
  }

  get isAllComplete(): boolean {
    return !this.requestList.length;
  }

  static getInstance(): FetchRequestList {
    if (this.instance) return this.instance;
    FetchRequestList.instance = new FetchRequestList();
    return this.instance;
  }
}

export default FetchRequestList;
